const IMAGE_TYPE = 'wix-draft-plugin-image';
const IMAGE_TYPE_LEGACY = 'IMAGE';
export { IMAGE_TYPE_LEGACY, IMAGE_TYPE };
